require ('./blocks/admin_review/admin_review');
require ('./blocks/rating/rating.less');
require ('./blocks/gadgets/gadgets');
require('jquery.maskedinput/dist/jquery.maskedinput');


// WEBPACK FOOTER //
// ./bitrix_admin.js